import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

import { ToastrService } from 'ngx-toastr'

import { environment } from 'src/environments/environment'

import { Mensagem } from 'src/app/models/mensagem.model'

import { MensagemService } from '../mensagens/mensagens.service'
import { LoginService } from 'src/app/shared/login.service'

const idMensagem = environment.message.id


@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
	mensagem: Mensagem
	textoMensagem: SafeHtml
	constructor(
		private mensagemService: MensagemService,
		private sanitized: DomSanitizer,
		private toastrService: ToastrService,
		private router: Router
	) {
		this.getMensagemPorID(idMensagem)
	}

	ngOnInit(): void {
	}

	getInnerHTMLValue(value: string) {
		this.textoMensagem = this.sanitized.bypassSecurityTrustHtml(value)
	}

	getMensagemPorID(msgID: string) {
		this.mensagemService.getMensagemPorID(msgID).subscribe((res) => {
			if (res.status >= 400) {
				this.showAlertInfo(res.statusText)
			} else {
				this.mensagem = {
					id: res.mensagem.id,
					titulo: res.mensagem.titulo,
					texto: res.mensagem.texto,
				}
				this.getInnerHTMLValue(res.mensagem.texto)
			}
		})
	}

	showAlertInfo(msg: any) {
		this.toastrService.error(`${msg} - Ocorreu um erro ao fazer a chamada, por favor tente mais tarde!`, 'PTA - Portal de Transferência de Arquivos', {
			timeOut: 2000,
			closeButton: true,
		})
		this.router.navigateByUrl('/home')
	}
}
